/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * How one provider import run entered the system; never a publisher setting.
 */
export type ImportChannel = typeof ImportChannel[keyof typeof ImportChannel];


export const ImportChannel = {
  elibri_feed: 'elibri_feed',
  elibri_requeue: 'elibri_requeue',
  sheet_cli: 'sheet_cli',
  sheet_ingest: 'sheet_ingest',
  admin_requeue: 'admin_requeue',
  file_ingest: 'file_ingest',
  reimport: 'reimport',
} as const;
